export const tuckIn = function (el) {
    const keyWords = el.getAttribute("data-keyword").split(",");
    const inFooter =
        el.getAttribute("data-reveal-in-footer") == "true" ? true : false;

    window.addEventListener("scroll", function () {
        const article = el.closest("article");
        const articleProp = article.getBoundingClientRect();
        let max = articleProp.height - window.innerHeight * 2;
        if (!inFooter) {
            max = document.documentElement.getBoundingClientRect().height; // maxHeight, will never be exceeded
        }
        console.log(
            "Test",
            article.querySelector("h1").innerText,
            articleProp.height - window.innerHeight + articleProp.top < 0
        );

        keyWords.forEach(function (keyWord) {
            if (window.innerWidth > 1023) {
                if (
                    !el.classList.contains(`${keyWord}--tuck-in`) &&
                    articleProp.top < -window.innerHeight &&
                    max + articleProp.top > 0
                ) {
                    console.log("to tuck in state");
                    el.classList.add(`${keyWord}--tuck-in`);
                } else if (
                    el.classList.contains(`${keyWord}--tuck-in`) &&
                    max + articleProp.top < 0 &&
                    articleProp.height -
                        (window.innerHeight / 3) * 2 +
                        articleProp.top >
                        0
                ) {
                    el.classList.remove(`${keyWord}--tuck-in`);
                    console.log("tucking out - end");
                } else if (
                    !el.classList.contains(`${keyWord}--tuck-in`) &&
                    articleProp.height -
                        (window.innerHeight / 3) * 2 +
                        articleProp.top <
                        0
                ) {
                    el.classList.add(`${keyWord}--tuck-in`);
                    console.log("tucking in again - very end ");
                } else if (
                    el.classList.contains(`${keyWord}--tuck-in`) &&
                    articleProp.top > -window.innerHeight &&
                    articleProp.top < 0
                ) {
                    el.classList.remove(`${keyWord}--tuck-in`);
                    console.log("tucking out - begin");
                } else if (
                    !el.classList.contains(`${keyWord}--tuck-in`) &&
                    articleProp.top > 0
                ) {
                    el.classList.add(`${keyWord}--tuck-in`);
                    console.log("tucking out - begin");
                }
            } else {
                el.classList.add(`${keyWord}--tuck-in`);
            }
        });
    });
};

export const tuckOut = function (el) {
    const target = el.closest(el.getAttribute("data-selector"));
    const keyWord = el.getAttribute("data-keyword");
    el.addEventListener("mouseenter", function () {
        console.log("tuckout");
        target.classList.remove(keyWord + "--tuck-in");
    });
    el.addEventListener("click", function () {
        console.log("tuckout");
        target.classList.remove(keyWord + "--tuck-in");
    });
};
